/* eslint-disable max-lines */
import type { GlobalAttributesT, XstyledProps, ValidationMap } from '@elliemae/ds-props-helpers';
import { PropTypes, globalAttributesPropTypes } from '@elliemae/ds-props-helpers';
import { type DSTooltipV3T } from '@elliemae/ds-tooltip-v3';

export const defaultProps: DSCircularIndeterminateIndicatorT.DefaultProps = {
  size: 'm',
  color: 'dark',
  text: '',
  showText: true,
  withTooltip: false,
  inline: false,
  tooltipStartPlacementPreference: 'bottom',
};

export declare namespace DSCircularIndeterminateIndicatorT {
  type TShirtSizes = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
  type SupportedColors = 'light' | 'dark';
  export interface DefaultProps {
    size: TShirtSizes;
    color: SupportedColors;
    text: string;
    showText: boolean;
    withTooltip: boolean;
    inline: boolean;
    tooltipStartPlacementPreference: DSTooltipV3T.Placement;
  }
  export interface OptionalProps {}
  export interface RequiredProps {}

  export interface Props
    extends
      Partial<DefaultProps>,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLButtonElement>, keyof DefaultProps>,
      XstyledProps,
      RequiredProps {}

  export interface InternalProps
    extends
      DefaultProps,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLButtonElement>, keyof DefaultProps>,
      XstyledProps,
      RequiredProps {}
}

export const CircularIndeterminateIndicatorPropTypes = {
  ...globalAttributesPropTypes,
  size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']).description('Size of the indicator').defaultValue('m'),
  color: PropTypes.oneOf(['light', 'dark']).description('Color mode for the indicator').defaultValue('dark'),
  text: PropTypes.string.description('Optional text to show under the indicator').defaultValue(''),
  showText: PropTypes.bool.description('Whether to show the optional text or not').defaultValue(true),
  withTooltip: PropTypes.bool
    .description('Whether to include a tooltip that shows the optional text on hover')
    .defaultValue(false),
  inline: PropTypes.bool.description('Whether to show the indicator inline or not').defaultValue(false),
  tooltipStartPlacementPreference: PropTypes.oneOf([
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ])
    .description('start placement preference for the tooltip')
    .defaultValue('center'),
} as ValidationMap<unknown>;
